/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddProductQuickReviewDto } from '../../models/add-product-quick-review-dto';

export interface CreateQuickReview$Params {
  productId: number;
      body: AddProductQuickReviewDto
}

export function createQuickReview(http: HttpClient, rootUrl: string, params: CreateQuickReview$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'data'?: boolean;
}>> {
  const rb = new RequestBuilder(rootUrl, createQuickReview.PATH, 'post');
  if (params) {
    rb.path('productId', params.productId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'data'?: boolean;
      }>;
    })
  );
}

createQuickReview.PATH = '/api/v1/products/{productId}/quick-reviews';
